/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connection_Zero_CostInputs */



/**
* | output |
* | --- |
* | "oneAI charges nothing for these models." |
*
* @param {Private_Models_Connection_Zero_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_zero_cost = /** @type {((inputs?: Private_Models_Connection_Zero_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_Zero_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI berechnet für diese Modelle nichts.")
	return /** @type {LocalizedString} */ ("oneAI charges nothing for these models.")
});